export enum EventTriggers {
  MAIN_MENU = "Main Menu",
  TOP_MENU = "Top Menu",
  NEXT = "Next",
}